import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPageType } from '../../../selectors/page';
import { trackClickAllServicesButton, trackClickGoToAddFormLink } from '../utils';
import { mapPageTypeToAnalytics } from '../../../utils/getPageviewObject';

export const useTrackClicks = () => {
  const pageType = useSelector(selectPageType);

  const trackAllServicesClick = React.useCallback(() => {
    trackClickAllServicesButton(mapPageTypeToAnalytics[pageType]);
  }, [pageType]);

  const trackGoToAddFormLinkClick = React.useCallback(() => {
    trackClickGoToAddFormLink(mapPageTypeToAnalytics[pageType]);
  }, [pageType]);

  return {
    trackAllServicesClick,
    trackGoToAddFormLinkClick,
  };
};
